module.exports = __webpack_public_path__ + "e79bfd88537def476913f3ed52f4f4b3.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-design-icons/iconfont/MaterialIcons-Regular.eot
 ** module id = 16
 ** module chunks = 0
 **/